"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-border/50 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/OurMedicalTeamPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Our Medical Team
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/WellnessServicesPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Wellness Services
          </Link>
        </li>
        <li data-index={3}>
          <Link to="/EmergencyPharmacyPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Emergency & Pharmacy
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    label: "Facebook",
    href: "#"
  }, {
    icon: Twitter,
    label: "Twitter",
    href: "#"
  }, {
    icon: Linkedin,
    label: "LinkedIn",
    href: "#"
  }, {
    icon: Instagram,
    label: "Instagram",
    href: "#"
  }];
  return <section data-section-id="264782" id="footer" className="dark bg-background pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs font-default">
              City Pet Care provides modern, compassionate veterinary services in an urban oasis designed for your pet's comfort and health.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-tight">
              Quick Links
            </h3>
            <MenuProvider menu_id="44">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-tight">
              Clinic Hours
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                <span className="w-24 shrink-0">Mon - Fri:</span>
                <span>8:00 AM - 7:00 PM</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                <span className="w-24 shrink-0">Saturday:</span>
                <span>9:00 AM - 4:00 PM</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-destructive font-default font-medium">
                <span className="w-24 shrink-0">Emergency:</span>
                <span>24/7 On-Call</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-tight">
              Get In Touch
            </h3>
            <ul className="space-y-4 mb-6">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <Phone className="size-4 mt-0.5 shrink-0 text-primary" />
                <span className="font-default">(555) 987-PETS</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <Mail className="size-4 mt-0.5 shrink-0 text-primary" />
                <span className="font-default">hello@citypetcare.com</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary" />
                <span className="font-default">456 Urban Way, Metro City</span>
              </li>
            </ul>
            <div className="flex flex-wrap gap-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="outline" size="icon" asChild className="bg-card/40 border-border/50 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 rounded-lg shadow-sm">
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

        </div>

        <Separator className="my-10 bg-border/20" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground font-default">
          <p>
            &copy; {currentYear} City Pet Care Veterinary Clinic. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
            <Link to="/EmergencyPharmacyPage" className="hover:text-destructive transition-colors font-medium">
              Online Pharmacy
            </Link>
          </div>
        </div>
      </div>
    </section>;
}